import { urlJoinP } from 'url-join-ts';

import { createAxiosInstance } from '@app/common';
import { environment } from '@app/environments/environment';

type QueryStringObject = Record<string, any>;

export class ApiServiceBase {
    readonly #axios = createAxiosInstance();
    protected get ApiHost(): string {
        return environment.SSR_API_HOST || 'http://localhost:3001/api/';
    }

    protected async query<TModel>(url: string, queryParams?: QueryStringObject) {
        const newUrl = urlJoinP(this.ApiHost, [url, '/'], queryParams);

        const response = await this.#axios.get<TModel>(newUrl, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }
}
